// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hm-6";
export var emphasizeQuantity = "_hm-3";
export var flatBottomCorners = "_hm-5";
export var productImage = "_hm-0";
export var quantityContainer = "_hm-2";
export var tooltip = "_hm-1";
export var wrapAndEllipsesOverflow = "_hm-4";